export default function (nga, admin, activities, groups, exercises, properties, values) {
    var evaluationsCount = admin.getEntity('evaluations_grouped')
            .url(function(entityName, viewType, identifierValue, identifierName) {
                return '/evaluations_grouped/';
            });
    evaluationsCount.listView()
        .title('{{ "Evaluations" | translate }}')
        .fields([
            nga.field('id')
                .map(function truncate(value, entry) {
                    return entry['exercise_id'] + '_' + entry['value_id'];
                })
                .sortable(false)
                .cssClasses(() => 'hide'),
            nga.field('total')
                .map((value, entry) => { return entry['count'] + '/' + entry['total']})
                .label('Count'),
            nga.field('percentage', 'float')
                .map((value, entry) => {
                    var total = entry['total'].split('/')[1];
                    return entry['count'] / parseInt(total, 10) * 100;
                })
                .label('%')
                .sortable(false)
                .format('0.00'),
            nga.field('value_name', 'string')
                .label('Value'),
            nga.field('property_name', 'string')
                .label('Property'),
            nga.field('exercise_title', 'string')
                .label('Title'),
            nga.field('activity_name', 'string')
                .label('Activity')
        ])
        .filters([
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .filters([
                    nga.field('with_exercises').defaultValue(true)
                ])
                .label('Activity'),
            nga.field('group_id', 'reference')
                .targetEntity(groups)
                .targetField(nga.field('name'))
                .label('Group'),
            nga.field('property_id', 'reference')
                .targetEntity(properties)
                .targetField(nga.field('name').map(function(value, entry) {
                    return entry['activity.name'] + ' - '+ value;
                }))
                .label('Property'),
            nga.field('value_id', 'reference')
                .targetEntity(values)
                .targetField(
                    nga.field('name').map(function(value, entry) {
                        return entry['activity.name'] + ' - ' + entry['property.name'] + ' - '+ value;
                    })
                )
                .label('Value'),
            nga.field('q', 'template')
                .label('Exercise')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'),
            /*
             * FIXME:
             * A reference field by exercise doesn't work properly. It displays
             * only the first 30 exercises (as the request uses a per_page
             * attribute of 30) and doesn't perform an additional lookup once
             * the user introduces a text in the search box.
             */
            // nga.field('exercise_id', 'reference')
            //     .targetEntity(exercises)
            //     .targetField(nga.field('title'))
            //     .label('Exercise'),
            nga.field('months', 'template')
                .label('Time range')
                /* FIXME: https://github.com/marmelab/ng-admin/issues/1204
                 * When accesing through the menu the link will add as filter
                 * the parameters of the pinned field. However when going
                 * straight to the /list view the pinned filter is blank.
                 */
                .pinned(true)
                // FIXME: convert-to-number directive keeps sending months filter as strings
                .defaultValue('2')
                .template(`
<div class="input-group">
    <select ng-model="value" class="form-control">
        <option value="2">{{ "LAST_N_MONTHS" | translate : \'{ amount: 2 }\' }}</option>
        <option value="3">{{ "LAST_N_MONTHS" | translate : \'{ amount: 3 }\' }}</option>
        <option value="6">{{ "LAST_N_MONTHS" | translate : \'{ amount: 6 }\' }}</option>
    </select>
</div>`)
        ])
        .sortField('count')
        .sortDir('DESC')
        .actions(['filter'])
        .listActions(['<ma-filtered-list-button entity-name="evaluations" filter="{ value_id: entry.values.value_id, q: entry.values.exercise_title }" size="xs"></ma-filtered-list-button>'])
    return evaluationsCount;
}



// WEBPACK FOOTER //
// ./js/evaluations_grouped/config.js